import { Fragment, type ReactNode } from 'react';

/**
 * Renderiza un texto del diccionario que lleva un fragmento resaltado, marcado
 * como `<g>…</g>`.
 *
 * Existe por el `<h1>` del home: "El **Google Analytics** para eventos físicos"
 * lleva el degradado de marca *en medio* de la frase. Partir la cadena en tres
 * campos ("antes", "resaltado", "después") funcionaría para español e inglés
 * por casualidad, pero deja al traductor sin poder mover el resaltado — y hay
 * idiomas donde no va en el mismo lugar. Con el marcador dentro de la cadena,
 * el resaltado viaja con la traducción.
 *
 * **No interpreta HTML.** Reconoce esta única etiqueta y todo lo demás se emite
 * como texto de React, así que un diccionario no puede inyectar marcado.
 */
const MARCA = /<g>([\s\S]*?)<\/g>/g;

interface Props {
  texto: string;
  /** Cómo se envuelve el fragmento marcado. Por omisión, el degradado de marca. */
  envoltura?: (contenido: ReactNode) => ReactNode;
}

const DEGRADADO = (contenido: ReactNode) => (
  <span className="ilu-gradient-text">{contenido}</span>
);

export function TextoRico({ texto, envoltura = DEGRADADO }: Props) {
  const partes: ReactNode[] = [];
  let cursor = 0;

  for (const coincidencia of texto.matchAll(MARCA)) {
    const inicio = coincidencia.index ?? 0;
    if (inicio > cursor) partes.push(texto.slice(cursor, inicio));
    partes.push(<Fragment key={inicio}>{envoltura(coincidencia[1])}</Fragment>);
    cursor = inicio + coincidencia[0].length;
  }
  if (cursor < texto.length) partes.push(texto.slice(cursor));

  return <>{partes}</>;
}
